import { useEffect } from "react";
import { getUsersCustomerToMission } from "../../../../services/Api/customerService";
import { useParams } from "react-router-dom";
import { usePartnerMissionStore } from "../../../../stores/Cac/Partner/partnerMission";
import { usePartnerRequestsStore2 } from "../../../../stores/Cac/Partner/partnerRequests";
import { showToastError } from "../../../../services/Toasts/toasts";

const SelectedUsersRequest = () => {
  const { idCustomer, idMission } = useParams();
  const { usersClients, setUsersClients } = usePartnerMissionStore();
  const { selectedUserToAffected, setSelectedUserToAffected } =
    usePartnerRequestsStore2();

  useEffect(() => {
    getUsersCustomerToMission(Number(idCustomer), idMission)
      .then((data) => setUsersClients(data))
      .catch(() => showToastError("Une erreur s'est produite"));
  }, [idMission]);

  const handleSelectChange = (e: any) => {
    const selectedId = parseInt(e.target.value);
    const selectedUser = usersClients?.find(
      (client) => client.id === selectedId
    );
    setSelectedUserToAffected({
      id: selectedId,
      fullName: selectedUser.fullName,
      eMail: selectedUser.eMail,
    });
  };

  return (
    <div className="w-full flex justify-start items-center font-BarlowCondensed ">
      <select
        name="usersClients"
        id="usersClients"
        onChange={handleSelectChange}
        value={selectedUserToAffected.id}
        className="w-44 pr-4 py-2 border border-gray-200 text-md rounded-xl bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm hover:shadow-md focus:shadow-lg font-medium search-input"
      >
        <option value="" className="text-gray-400">
          Selectionner un utilisateur
        </option>
        {usersClients.length > 0 ? usersClients?.map((client) => (
          <option
            value={client?.id}
            key={client?.id}
            className="text-nxm-dark-gray text-sm"
          >
            {client?.fullName === "" ? client.eMail : client.fullName}
          </option>
        )) : <option value="" className="text-gray">Pas d'utilisateur</option>}
      </select>
    </div>
  );
};

export default SelectedUsersRequest;
